/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reps: NonNullable<unknown> }} Progress_Report_Exercise_RepsInputs */

const en_us2_progress_report_exercise_reps = /** @type {(inputs: Progress_Report_Exercise_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 rep`);
	return /** @type {LocalizedString} */ (`${i?.reps} reps`)
	
};

const pt_br2_progress_report_exercise_reps = /** @type {(inputs: Progress_Report_Exercise_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 repetição`);
	return /** @type {LocalizedString} */ (`${i?.reps} repetições`)
	
};

const es_419_progress_report_exercise_reps = /** @type {(inputs: Progress_Report_Exercise_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 repetición`);
	return /** @type {LocalizedString} */ (`${i?.reps} repeticiones`)
	
};

const pt_pt2_progress_report_exercise_reps = /** @type {(inputs: Progress_Report_Exercise_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 repetição`);
	return /** @type {LocalizedString} */ (`${i?.reps} repetições`)
	
};

const fr_fr2_progress_report_exercise_reps = /** @type {(inputs: Progress_Report_Exercise_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 répétition`);
	return /** @type {LocalizedString} */ (`${i?.reps} répétitions`)
	
};

const de_de2_progress_report_exercise_reps = /** @type {(inputs: Progress_Report_Exercise_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 Wdh.`);
	return /** @type {LocalizedString} */ (`${i?.reps} Wdh.`)
	
};

const it_it2_progress_report_exercise_reps = /** @type {(inputs: Progress_Report_Exercise_RepsInputs) => LocalizedString} */ (i) => {
	if ((i?.reps === 1 || i?.reps === "1")) return /** @type {LocalizedString} */ (`1 ripetizione`);
	return /** @type {LocalizedString} */ (`${i?.reps} ripetizioni`)
	
};

/**
* | reps | output |
* | --- | --- |
* | "1" | "1 rep" |
* | * | "{reps} reps" |
*
* @param {Progress_Report_Exercise_RepsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_exercise_reps = /** @type {((inputs: Progress_Report_Exercise_RepsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Exercise_RepsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_exercise_reps(inputs)
	if (locale === "es-419") return es_419_progress_report_exercise_reps(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_exercise_reps(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_exercise_reps(inputs)
	if (locale === "de-DE") return de_de2_progress_report_exercise_reps(inputs)
	if (locale === "it-IT") return it_it2_progress_report_exercise_reps(inputs)
	return en_us2_progress_report_exercise_reps(inputs)
});
export { progress_report_exercise_reps as "progress-report.exercise_reps" }